<div class="box ml-2 mr-2">
  <div class="box-header">

    <div class="row flex-align-center px-3 mt-3 mb-2">
      <div class="col-sm-12 text-sm-right mb-sm-2">
        <button mat-raised-button color="primary" matTooltip="{{'Add_User_Tool_Tip' | translate}}" (click)="addUser()">
          <mat-icon>person_add</mat-icon>
          {{'Add User' | translate}}
        </button>
      </div>
      <div class="ml-auto">
        <form [formGroup]="dcUserForm">
          <label   class="font-weight-500">{{'Filters' | translate}} :</label>
          <mat-radio-group formControlName="status" aria-label="Select an option">
            <mat-radio-button  matTooltip="{{'All_Users_Tool_Tip' | translate}}"  value="" class="mx-2" color="primary">{{'All Users' | translate}}</mat-radio-button>
            <mat-radio-button  matTooltip="{{'Active_Tool_Tip' | translate}}"  value="Y" class="mx-2" color="primary">{{'Active' | translate}}</mat-radio-button>
            <mat-radio-button   matTooltip="{{'Inactive_Tool_Tip' | translate}}"  value="N" class="mx-2" color="primary">{{'Inactive' | translate}}</mat-radio-button>
          </mat-radio-group>
        </form>
      </div>
    </div>
    <div class="grid-filter">
      <div class="actions">
        <div class="row">
          <div class="col-md-6 flex-align-center">
            <form [formGroup]="dcUserForm">
              <mat-form-field appearance="outline">
                <mat-label>{{'DC Location' | translate}}</mat-label>
                <mat-select formControlName="dcNumber" disableOptionCentering>
                  @for (dc of dcNumbers; track dc) {
                    <mat-option [value]="dc.dcNumber">
                      {{ dc.dcLocation}} - {{dc.dcName}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </form>
            <button mat-raised-button (click)="getUsersData()" [disabled]="!dcUserForm.valid"
              class="ml-2 mt-2 ml-sm-auto">
              {{'Filter' | translate}}
            </button>

          </div>
          <div class="col-md-6 flex-align-center justify-md-right">
            <mat-form-field>
              <mat-label>{{'Search' | translate}}</mat-label>
              <input matInput placeholder="Placeholder" (keyup)="applyFilter($event.target.value)"  />
              <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>

          </div>
        </div>
      </div>
    </div>

  </div>
  <div class="box-body">
    <mat-table  [dataSource]="dataSource" class="mat-elevation-z8 order-summary-table" matSort (matSortChange)="sortData($event)">
      <!-- Position Column -->

      <ng-container matColumnDef="upn" >
        <mat-header-cell   *matHeaderCellDef mat-sort-header disableClear> {{'User ID' | translate}}</mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ element.upn }} </mat-cell>
      </ng-container>

      <!-- <ng-container matColumnDef="userid">
      <mat-header-cell *matHeaderCellDef mat-sort-header disableClear> {{'User ID' | translate}} </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{ element.userId }} </mat-cell>
    </ng-container> -->

    <!-- Name Column -->
    <ng-container matColumnDef="firstname">
      <mat-header-cell *matHeaderCellDef  mat-sort-header disableClear> {{'First Name' | translate}} </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{ element.firstName }} </mat-cell>
    </ng-container>

    <!-- Weight Column -->
    <ng-container matColumnDef="lastname">
      <mat-header-cell *matHeaderCellDef mat-sort-header disableClear > {{'Last Name' | translate}} </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{ element.lastName }} </mat-cell>
    </ng-container>

    <!-- Symbol Column -->
    <!-- <ng-container matColumnDef="license">
    <mat-header-cell *matHeaderCellDef mat-sort-header disableClear> {{'Licence #' | translate}} </mat-header-cell>
    <mat-cell *matCellDef="let element"> {{ element.license }} </mat-cell>
  </ng-container> -->

  <ng-container matColumnDef="userrole">
    <mat-header-cell *matHeaderCellDef mat-sort-header disableClear > {{'User Role' | translate}} </mat-header-cell>
    <mat-cell *matCellDef="let element"> {{ element.roleName | translate }} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="status">
    <mat-header-cell  *matHeaderCellDef mat-sort-header disableClear> {{'Status' | translate}} </mat-header-cell>
    <mat-cell *matCellDef="let element"> {{ (element.userStatus==='Y'?'Active':'Inactive' ) | translate | uppercase  }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="action">
    <mat-header-cell    *matHeaderCellDef> {{'Action' | translate}} </mat-header-cell>
    <mat-cell *matCellDef="let element"> <button mat-icon-button  matTooltip="{{'ViewDetailsTooltip' | translate}}" (click)="editUser(element,'edit')">
      <mat-icon>visibility</mat-icon>

    </button> </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
</mat-table>


</div>

<div class="box-footer">
  <mat-paginator [length]="resultsLength" [pageSize]="15" showFirstLastButtons></mat-paginator>

</div>
</div>